/* ============================================================
   Overflow Vinyl — Custom Designer logic (vanilla JS)
   Reads live product JSON + config from the section, renders
   the configurator, computes the estimate, and posts the
   design to /cart/add.js as line item properties.

   NOTE: file upload to Shopify Files is wired in Phase 3.
   Until then, _*_url carries a placeholder marker so the
   rest of the flow can be tested end to end.
   ============================================================ */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.ovInit === '1') return;
    root.dataset.ovInit = '1';

    var fmt = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };
    // Mute the Yuva theme's add-to-cart sound globally (the designer handles its own feedback)
    (function muteSnd(){ var el=document.getElementById('addToCartAlert'); if(el){el.muted=true;el.volume=0;return;} document.addEventListener('DOMContentLoaded',function(){var e=document.getElementById('addToCartAlert');if(e){e.muted=true;e.volume=0;}}); })();
    var artTransform = function (t) {
      t = t || { scale: 1, x: 0, y: 0 };
      return 'translate(-50%,-50%) translate(' + (t.x || 0) + 'px,' + (t.y || 0) + 'px) scale(' + (t.scale || 1) + ')';
    };

    // Tint a transparent shirt photo to a color on a <canvas> (multiply for shading,
    // clipped to the shirt's alpha so only the garment colors).
    var shirtImgCache = {};
    function paintShirt(canvas, url, hex) {
      var img = shirtImgCache[url];
      function draw() {
        var w = img.naturalWidth, h = img.naturalHeight; if (!w || !h) return;
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, w, h); ctx.drawImage(img, 0, 0, w, h);
        if (hex && hex.toLowerCase() !== '#ffffff') {
          ctx.globalCompositeOperation = 'multiply'; ctx.fillStyle = hex; ctx.fillRect(0, 0, w, h);
          ctx.globalCompositeOperation = 'destination-in'; ctx.drawImage(img, 0, 0, w, h);
          ctx.globalCompositeOperation = 'source-over';
        }
      }
      if (!img) {
        img = new Image(); shirtImgCache[url] = img;
        img.onerror = function () {
          var pw = root.querySelector('[data-ov-photo-wrap]'), ph = root.querySelector('[data-ov-shirt-shape]');
          if (pw) pw.hidden = true; if (ph) ph.style.display = '';
        };
        img.src = url;
      }
      if (img.complete && img.naturalWidth) draw(); else img.onload = draw;
    }
    var $ = function (sel) { return root.querySelector(sel); };
    var $all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var PRODUCT = JSON.parse(root.querySelector('[data-ov-product]').textContent);
    var CFG = JSON.parse(root.querySelector('[data-ov-config]').textContent);

    var SIZE_OPTION_INDEX = (PRODUCT.options || []).findIndex(function (o) {
      return String(o.name || o).toLowerCase() === 'size';
    });
    var GARMENT_OPTION_INDEX = (PRODUCT.options || []).findIndex(function (o) {
      return String(o.name || o).toLowerCase() === 'garment';
    });
    if (GARMENT_OPTION_INDEX < 0) GARMENT_OPTION_INDEX = 0;
    if (SIZE_OPTION_INDEX < 0) SIZE_OPTION_INDEX = 1;

    // ---- Build garment + size lists from live variants ----
    var price = function (v) { return (v.price || 0) / 100; }; // product|json prices are in cents
    var garmentOrder = [], sizesSet = [];
    PRODUCT.variants.forEach(function (v) {
      var g = v.options[GARMENT_OPTION_INDEX];
      var s = v.options[SIZE_OPTION_INDEX];
      if (garmentOrder.indexOf(g) < 0) garmentOrder.push(g);
      if (sizesSet.indexOf(s) < 0) sizesSet.push(s);
    });

    var GARMENTS = garmentOrder.map(function (name) {
      var rows = PRODUCT.variants.filter(function (v) { return v.options[GARMENT_OPTION_INDEX] === name; });
      var nonXXL = rows.filter(function (v) { return v.options[SIZE_OPTION_INDEX] !== '2XL'; });
      var xxl = rows.filter(function (v) { return v.options[SIZE_OPTION_INDEX] === '2XL'; });
      var base = Math.min.apply(null, (nonXXL.length ? nonXXL : rows).map(price));
      var base2 = xxl.length ? Math.min.apply(null, xxl.map(price)) : base;
      return { name: name, base: base, base2XL: base2, shape: CFG.shapes[name] || 'tee' };
    });

    var zoneById = {};
    CFG.zones.forEach(function (z) { zoneById[z.id] = z; });

    // ---- State ----
    var state = {
      garment: GARMENTS[0].name,
      colorId: CFG.colors[0].id,
      sizeQty: {}, // { size: quantity } — multiple sizes per design
      view: 'front',
      graphicFee: false,
      zones: {} // { zoneId: {dataUrl, name, sizeBytes, dpi, isOk, w, h, vector, url} }
    };
    sizesSet.forEach(function (s) { state.sizeQty[s] = 0; });

    function garment() { return GARMENTS.filter(function (g) { return g.name === state.garment; })[0]; }
    function color() { return CFG.colors.filter(function (c) { return c.id === state.colorId; })[0]; }
    function priceForSize(size) { var g = garment(); return size === '2XL' ? g.base2XL : g.base; }
    function totalUnits() { return sizesSet.reduce(function (n, s) { return n + (state.sizeQty[s] || 0); }, 0); }
    function sizesWithQty() { return sizesSet.filter(function (s) { return (state.sizeQty[s] || 0) > 0; }); }

    function activeZoneIds() { return Object.keys(state.zones); }

    // ---- Pricing (bundle combos override additive) ----
    function printPrice() {
      var ids = activeZoneIds();
      for (var i = 0; i < CFG.bundles.length; i++) {
        var b = CFG.bundles[i];
        if (b.zones.length === ids.length && b.zones.every(function (z) { return ids.indexOf(z) >= 0; })) {
          return b.comboPrice;
        }
      }
      return ids.reduce(function (sum, id) { return sum + zoneById[id].price; }, 0);
    }

    function bulkRate(qty) {
      for (var i = 0; i < CFG.bulk.length; i++) { if (qty >= CFG.bulk[i].min) return CFG.bulk[i]; }
      return null;
    }

    function compute() {
      var pp = printPrice(), merch = 0, garmentMerch = 0, units = 0;
      sizesSet.forEach(function (s) {
        var q = state.sizeQty[s] || 0;
        if (q > 0) { merch += (priceForSize(s) + pp) * q; garmentMerch += priceForSize(s) * q; units += q; }
      });
      var bulk = bulkRate(units);
      // Bulk discount applies to the garment subtotal (matches the native Shopify discount scoped to the shirt)
      var discount = bulk ? garmentMerch * bulk.rate : 0;
      var afterBulk = merch - discount;
      // Setup fee only matters once there's an actual design + at least one unit
      var hasDesign = activeZoneIds().length > 0;
      var manual = (hasDesign && units > 0 && afterBulk > 0 && afterBulk < CFG.manualFeeThreshold) ? CFG.manualFee : 0;
      var graphic = state.graphicFee ? CFG.graphicFee : 0;
      var total = afterBulk + manual + graphic;
      return { merch: merch, units: units, bulk: bulk, discount: discount, afterBulk: afterBulk, manual: manual, graphic: graphic, total: total };
    }

    // ---- Variant resolution ----
    function variantForSize(size) {
      return PRODUCT.variants.filter(function (v) {
        return v.options[GARMENT_OPTION_INDEX] === state.garment && v.options[SIZE_OPTION_INDEX] === size;
      })[0];
    }

    // ---- Toast ----
    var toastEl = $('[data-ov-toast]'), toastTimer;
    function toast(msg, type) {
      toastEl.textContent = msg;
      toastEl.setAttribute('data-type', type || 'info');
      toastEl.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 3500);
    }

    // ---- File handling ----
    var VECTOR_EXT = ['svg', 'pdf', 'ai'];
    function handleFile(zoneId, file) {
      if (!file) return;
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      var isVector = VECTOR_EXT.indexOf(ext) >= 0;
      var maxBytes = CFG.maxFileMb * 1024 * 1024;
      if (file.size > maxBytes) { toast('File too large (max ' + CFG.maxFileMb + 'MB)', 'error'); return; }
      if (!isVector && !file.type.indexOf('image/') === 0 && !/(png|jpe?g)$/.test(ext)) {
        toast('Use PNG, JPG, SVG, PDF or AI', 'error'); return;
      }

      var zone = zoneById[zoneId];
      var conflicts = CFG.conflicts[zoneId] || [];

      var finish = function (dataUrl, w, h) {
        var dpi = null, isOk = true;
        if (!isVector && w && h) {
          dpi = Math.floor(Math.min(w / zone.printIn.w, h / zone.printIn.h));
          isOk = dpi >= CFG.dpiRequired;
        }
        // mutual exclusion
        var clearedName = null;
        conflicts.forEach(function (c) { if (state.zones[c]) { clearedName = zoneById[c].name; delete state.zones[c]; } });

        state.zones[zoneId] = {
          dataUrl: dataUrl, name: file.name, sizeBytes: file.size,
          w: w, h: h, dpi: dpi, isOk: isOk, vector: isVector,
          t: { scale: 1, x: 0, y: 0 }, // position/zoom of the art within the zone crop frame
          url: null, uploading: true // set to the R2 URL once the upload proxy responds
        };

        if (clearedName) toast(zone.name + ' replaces ' + clearedName + " — they can't be combined.", 'info');
        else if (isVector) toast(zone.name + ' ready · Vector ✓', 'info');
        else if (!isOk) toast('Low resolution: ' + dpi + ' DPI (need ' + CFG.dpiRequired + ')', 'warning');
        else toast(zone.name + ' ready · ' + dpi + ' DPI ✓', 'info');

        state.view = zone.side;
        renderAll();
        uploadArtwork(zoneId, file); // store the real file in R2 via the upload proxy
      };

      var reader = new FileReader();
      reader.onload = function (e) {
        var dataUrl = e.target.result;
        if (isVector) { finish(dataUrl, null, null); return; }
        var img = new Image();
        img.onload = function () { finish(dataUrl, img.naturalWidth, img.naturalHeight); };
        img.onerror = function () { finish(dataUrl, null, null); };
        img.src = dataUrl;
      };
      reader.readAsDataURL(file);
    }

    // Upload the raw file to the R2 proxy; store the returned URL on the zone
    function uploadArtwork(zoneId, file) {
      if (!CFG.uploadUrl) { var z0 = state.zones[zoneId]; if (z0) z0.uploading = false; renderZoneList(); return; }
      fetch(CFG.uploadUrl, {
        method: 'POST',
        headers: { 'X-Filename': file.name, 'X-Filetype': file.type || 'application/octet-stream' },
        body: file
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var z = state.zones[zoneId];
          if (!z || z.name !== file.name || z.sizeBytes !== file.size) return; // replaced/removed meanwhile
          z.uploading = false;
          if (j && j.url) { z.url = j.url; }
          else { z.uploadFailed = true; toast('Artwork upload failed — please re-upload', 'warning'); }
          renderZoneList(); renderTotals();
        })
        .catch(function () {
          var z = state.zones[zoneId];
          if (z) { z.uploading = false; z.uploadFailed = true; }
          toast('Artwork upload failed — please re-upload', 'warning');
          renderZoneList(); renderTotals();
        });
    }

    function removeZone(zoneId) { delete state.zones[zoneId]; renderAll(); }
    function isZoneDisabled(zoneId) {
      return (CFG.conflicts[zoneId] || []).some(function (c) { return !!state.zones[c]; });
    }
    function allowedZoneIds() {
      var r = (CFG.shapeZones || {})[garment().shape];
      return (r && r.length) ? r : CFG.zones.map(function (z) { return z.id; });
    }
    function isZoneAllowed(id) { return allowedZoneIds().indexOf(id) >= 0; }
    function pruneZones() { Object.keys(state.zones).forEach(function (id) { if (!isZoneAllowed(id)) delete state.zones[id]; }); }

    // ---- Render ----
    function renderGarments() {
      var wrap = $('[data-ov-garments]');
      wrap.innerHTML = '';
      GARMENTS.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ov-garment' + (g.name === state.garment ? ' is-active' : '');
        var sub = (CFG.descriptors || {})[g.name];
        b.innerHTML = '<div class="ov-garment__name">' + g.name + '</div>' +
          (sub ? '<div class="ov-garment__sub">' + sub + '</div>' : '') +
          '<div class="ov-garment__price">from ' + fmt(g.base) + '</div>';
        b.addEventListener('click', function () { state.garment = g.name; renderAll(); });
        wrap.appendChild(b);
      });
    }

    function renderSizes() {
      var wrap = $('[data-ov-sizes]');
      wrap.innerHTML = '';
      var g = garment();
      sizesSet.forEach(function (s) {
        var q = state.sizeQty[s] || 0;
        var cell = document.createElement('div');
        cell.className = 'ov-sizecell' + (q > 0 ? ' is-active' : '');
        var up = (s === '2XL' && g.base2XL > g.base) ? '<span class="ov-sizecell__up">+$' + (g.base2XL - g.base).toFixed(0) + '</span>' : '';
        cell.innerHTML =
          '<div class="ov-sizecell__name">' + s + up + '</div>' +
          '<div class="ov-sizecell__qty">' +
            '<button type="button" class="ov-sizecell__btn" data-size-dec="' + s + '" aria-label="Decrease ' + s + '">−</button>' +
            '<input type="number" min="0" inputmode="numeric" class="ov-sizecell__input" data-size-input="' + s + '" value="' + q + '" aria-label="' + s + ' quantity">' +
            '<button type="button" class="ov-sizecell__btn" data-size-inc="' + s + '" aria-label="Increase ' + s + '">+</button>' +
          '</div>';
        wrap.appendChild(cell);
      });
    }

    function renderSwatches() {
      var wrap = $('[data-ov-swatches]');
      wrap.innerHTML = '';
      CFG.colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ov-swatch' + (c.id === state.colorId ? ' is-active' : '');
        b.style.background = c.hex;
        b.title = c.name;
        b.addEventListener('click', function () { state.colorId = c.id; renderAll(); });
        wrap.appendChild(b);
      });
      $('[data-ov-color-name]').textContent = color().name;
    }

    function renderStage() {
      var shirt = $('[data-ov-shirt]');
      shirt.style.setProperty('--ov-shirt-color', color().hex);
      shirt.setAttribute('data-shape', garment().shape);

      // Real shirt photo (color-tinted) when one is set for this shape+view; else placeholder shape
      var photoUrl = ((CFG.photos || {})[garment().shape] || {})[state.view] || '';
      var pWrap = $('[data-ov-photo-wrap]'), canvas = $('[data-ov-canvas]'), placeholder = $('[data-ov-shirt-shape]');
      if (photoUrl) {
        pWrap.hidden = false; placeholder.style.display = 'none';
        paintShirt(canvas, photoUrl, color().hex);
      } else {
        pWrap.hidden = true; placeholder.style.display = '';
      }

      $all('[data-ov-view]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-ov-view') === state.view);
      });

      CFG.zones.forEach(function (z) {
        var hot = root.querySelector('[data-ov-zone-hotspot="' + z.id + '"]');
        if (!hot) return;
        hot.hidden = (z.side !== state.view) || !isZoneAllowed(z.id);
        hot.setAttribute('data-label', z.name);
        var img = state.zones[z.id];
        if (img) {
          hot.classList.add('has-art');
          hot.innerHTML = '<img class="ov-zone-art" draggable="false" src="' + img.dataUrl + '" alt="" style="transform:' + artTransform(img.t) + '">' +
            '<span class="ov-handle" data-corner="nw"></span><span class="ov-handle" data-corner="ne"></span>' +
            '<span class="ov-handle" data-corner="se"></span><span class="ov-handle" data-corner="sw"></span>';
        } else {
          hot.classList.remove('has-art');
          hot.innerHTML = '';
        }
      });

      // Art editor toolbar — bound to the art-bearing zone in the current view
      var editZone = CFG.zones.filter(function (z) { return z.side === state.view && state.zones[z.id]; })[0];
      var ed = $('[data-ov-art-editor]');
      if (editZone) {
        ed.hidden = false;
        ed.setAttribute('data-edit-zone', editZone.id);
      } else {
        ed.hidden = true;
        ed.removeAttribute('data-edit-zone');
      }

      $('[data-ov-stage-meta]').textContent = state.garment + (totalUnits() ? ' · ' + totalUnits() + ' pc' + (totalUnits() === 1 ? '' : 's') : '');
      var hasLow = activeZoneIds().some(function (id) { return !state.zones[id].isOk; });
      $('[data-ov-dpi-flag]').hidden = !hasLow;

      var n = activeZoneIds().length;
      $('[data-ov-stage-foot]').textContent = n
        ? (n + ' of ' + allowedZoneIds().length + ' zones · ' + color().name)
        : 'Click a dashed zone or use the panel →';
    }

    function renderZoneList() {
      var wrap = $('[data-ov-zone-list]');
      wrap.innerHTML = '';
      CFG.zones.filter(function (z) { return isZoneAllowed(z.id); }).forEach(function (z) {
        var img = state.zones[z.id];
        var disabled = isZoneDisabled(z.id) && !img;
        var row = document.createElement('div');
        row.className = 'ov-zone-row' + (img ? ' has-art' : '') + (disabled ? ' is-disabled' : '');

        var badge = '';
        if (img) {
          if (img.vector) badge = '<span class="ov-badge-ok">Vector ✓</span>';
          else if (img.isOk) badge = '<span class="ov-badge-ok">' + img.dpi + ' DPI ✓</span>';
          else badge = '<span class="ov-badge-low">⚠ ' + img.dpi + ' DPI · LOW</span>';
        }

        var meta = img
          ? (img.name + ' · ' + (img.w ? img.w + '×' + img.h + 'px · ' : '') + Math.round(img.sizeBytes / 1024) + 'KB')
          : (disabled
              ? ('Disabled · remove ' + (z.id === 'pocket' ? 'Full Front' : 'Pocket') + ' first')
              : (z.blurb + ' · ' + z.printIn.w + '" × ' + z.printIn.h + '"'));

        var actions = img
          ? '<div class="ov-zone-actions"><button type="button" class="ov-btn-mini ov-btn-replace" data-act="replace" data-zone="' + z.id + '">Replace</button>' +
            '<button type="button" class="ov-btn-mini ov-btn-remove" data-act="remove" data-zone="' + z.id + '">✕ Remove</button></div>'
          : '<button type="button" class="ov-btn-up" data-act="upload" data-zone="' + z.id + '"' + (disabled ? ' disabled' : '') + '>Upload</button>';

        row.innerHTML =
          '<div class="ov-zone-row__main">' +
            '<div class="ov-zone-thumb">' + (img ? '<img src="' + img.dataUrl + '" alt="">' : '🖼') + '</div>' +
            '<div class="ov-zone-info">' +
              '<div class="ov-zone-info__top"><span class="ov-zone-name">' + z.name + '</span>' +
                '<span class="ov-tag">+' + fmt(z.price) + '</span>' + badge + '</div>' +
              '<div class="ov-zone-meta">' + meta + '</div>' +
            '</div>' + actions +
          '</div>' +
          (img ? '<div class="ov-zone-url">' + (img.uploading ? '⏳ Uploading artwork…' : (img.url || '⚠ Upload failed — re-upload')) + '</div>' : '');

        row.addEventListener('mouseenter', function () { var h = root.querySelector('[data-ov-zone-hotspot="' + z.id + '"]'); if (h) h.style.borderColor = 'var(--ov-red)'; });
        row.addEventListener('mouseleave', function () { renderStage(); });
        wrap.appendChild(row);
      });
    }

    function renderTotals() {
      var c = compute();
      var bd = $('[data-ov-breakdown]');
      bd.innerHTML = '';
      function row(label, value, cls) {
        var d = document.createElement('div');
        d.className = 'ov-row' + (cls ? ' ' + cls : '');
        d.innerHTML = '<span>' + label + '</span><b>' + value + '</b>';
        bd.appendChild(d);
      }
      // Per-size lines (garment + prints, incl. bundle combo, per piece)
      var pp = printPrice();
      sizesWithQty().forEach(function (s) {
        row(state.garment + ' · ' + s + ' × ' + state.sizeQty[s], fmt((priceForSize(s) + pp) * state.sizeQty[s]));
      });
      if (c.graphic) row('Design assistance', fmt(c.graphic));
      if (c.manual) row('Setup fee (under ' + fmt(CFG.manualFeeThreshold) + ')', fmt(c.manual), 'is-muted');

      // Bulk savings — prominent callout directly above the total
      var sav = $('[data-ov-savings]');
      if (c.bulk) {
        sav.hidden = false;
        sav.innerHTML = '<span class="ov-savings__label">Bulk ' + (c.bulk.rate * 100).toFixed(0) + '% off shirts · ' + c.bulk.min + '+ pcs</span>' +
                        '<span class="ov-savings__amt">−' + fmt(c.discount) + '</span>';
      } else { sav.hidden = true; sav.innerHTML = ''; }

      $('[data-ov-total]').textContent = fmt(c.total);

      var any = activeZoneIds().length > 0;
      var hasQty = c.units > 0;
      var atc = $('[data-ov-atc]');
      atc.disabled = !(any && hasQty);
      $('[data-ov-atc-label]').textContent = !any ? 'Upload artwork to continue'
        : !hasQty ? 'Add a size quantity'
        : 'Add to Cart';
    }

    function renderAll() { pruneZones(); renderGarments(); renderSizes(); renderSwatches(); renderStage(); renderZoneList(); renderTotals(); }

    // ---- Events ----
    $all('[data-ov-view]').forEach(function (t) {
      t.addEventListener('click', function () { state.view = t.getAttribute('data-ov-view'); renderStage(); });
    });
    root.addEventListener('click', function (e) {
      var hot = e.target.closest('[data-ov-zone-hotspot]');
      if (hot && root.contains(hot)) {
        var id = hot.getAttribute('data-ov-zone-hotspot');
        if (!state.zones[id] && !isZoneDisabled(id)) triggerUpload(id);
      }
      var btn = e.target.closest('[data-act]');
      if (btn) {
        var zoneId = btn.getAttribute('data-zone');
        var act = btn.getAttribute('data-act');
        if (act === 'remove') removeZone(zoneId);
        else triggerUpload(zoneId);
      }
    });
    function triggerUpload(zoneId) { var inp = root.querySelector('[data-ov-file="' + zoneId + '"]'); if (inp) inp.click(); }
    CFG.zones.forEach(function (z) {
      var inp = root.querySelector('[data-ov-file="' + z.id + '"]');
      inp.addEventListener('change', function (e) { handleFile(z.id, e.target.files[0]); e.target.value = ''; });
    });

    // ---- In-zone art editor: drag artwork to move, drag a corner handle to resize ----
    var drag = null;
    function pinchDist(touches) {
      var dx = touches[0].clientX - touches[1].clientX, dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function applyArt(id) {
      var art = root.querySelector('[data-ov-zone-hotspot="' + id + '"] .ov-zone-art');
      if (art) art.style.transform = artTransform(state.zones[id].t);
    }
    function zoneFromEvent(e) {
      var hot = e.target.closest && e.target.closest('[data-ov-zone-hotspot].has-art');
      if (!hot || !root.contains(hot)) return null;
      var id = hot.getAttribute('data-ov-zone-hotspot');
      return state.zones[id] ? { id: id, hot: hot } : null;
    }
    function startGesture(id, hot, x, y, onHandle) {
      var t = state.zones[id].t;
      if (onHandle) {
        var rect = hot.getBoundingClientRect();
        var cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;
        drag = { id: id, mode: 'resize', cx: cx, cy: cy, d0: Math.max(8, Math.sqrt((x - cx) * (x - cx) + (y - cy) * (y - cy))), s0: t.scale };
      } else {
        drag = { id: id, mode: 'move', sx: x, sy: y, ox: t.x, oy: t.y };
      }
    }
    function moveGesture(x, y) {
      if (!drag) return;
      var t = state.zones[drag.id].t;
      if (drag.mode === 'resize') {
        var d = Math.sqrt((x - drag.cx) * (x - drag.cx) + (y - drag.cy) * (y - drag.cy));
        t.scale = Math.min(5, Math.max(0.2, drag.s0 * (d / drag.d0)));
      } else if (drag.mode === 'move') {
        t.x = drag.ox + (x - drag.sx);
        t.y = drag.oy + (y - drag.sy);
      }
      applyArt(drag.id);
    }
    root.addEventListener('mousedown', function (e) {
      var z = zoneFromEvent(e); if (!z) return;
      var onHandle = !!e.target.closest('.ov-handle');
      if (!onHandle && !e.target.closest('.ov-zone-art')) return;
      e.preventDefault();
      startGesture(z.id, z.hot, e.clientX, e.clientY, onHandle);
    });
    window.addEventListener('mousemove', function (e) { if (drag) moveGesture(e.clientX, e.clientY); });
    window.addEventListener('mouseup', function () { drag = null; });
    root.addEventListener('touchstart', function (e) {
      var z = zoneFromEvent(e); if (!z) return;
      var onHandle = !!e.target.closest('.ov-handle');
      if (!onHandle && !e.target.closest('.ov-zone-art')) return;
      if (e.touches.length === 2) { var t = state.zones[z.id].t; drag = { id: z.id, mode: 'pinch', pinch: pinchDist(e.touches), os: t.scale }; }
      else startGesture(z.id, z.hot, e.touches[0].clientX, e.touches[0].clientY, onHandle);
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!drag) return;
      if (drag.mode === 'pinch') { var t = state.zones[drag.id].t; t.scale = Math.min(5, Math.max(0.2, drag.os * (pinchDist(e.touches) / drag.pinch))); applyArt(drag.id); }
      else moveGesture(e.touches[0].clientX, e.touches[0].clientY);
      if (e.cancelable) e.preventDefault();
    }, { passive: false });
    root.addEventListener('touchend', function () { drag = null; });

    (function () {
      var ed = $('[data-ov-art-editor]');
      ed.querySelector('[data-ov-reset]').addEventListener('click', function () {
        var id = ed.getAttribute('data-edit-zone'); if (!id || !state.zones[id]) return;
        state.zones[id].t = { scale: 1, x: 0, y: 0 };
        renderStage();
      });
    })();

    // Per-size quantity controls (delegated — the grid is re-rendered on change)
    root.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-size-dec]');
      var inc = e.target.closest('[data-size-inc]');
      if (dec) { var s = dec.getAttribute('data-size-dec'); state.sizeQty[s] = Math.max(0, (state.sizeQty[s] || 0) - 1); renderSizes(); renderTotals(); }
      else if (inc) { var s2 = inc.getAttribute('data-size-inc'); state.sizeQty[s2] = (state.sizeQty[s2] || 0) + 1; renderSizes(); renderTotals(); }
    });
    root.addEventListener('input', function (e) {
      var inp = e.target.closest('[data-size-input]');
      if (!inp) return;
      var s = inp.getAttribute('data-size-input');
      var v = parseInt(inp.value, 10); if (isNaN(v) || v < 0) v = 0;
      state.sizeQty[s] = v; renderTotals();
    });
    $('[data-ov-graphic-fee]').addEventListener('change', function (e) { state.graphicFee = e.target.checked; renderTotals(); });

    // ---- Add to cart ----
    var modal = $('[data-ov-modal]');
    $('[data-ov-modal-cancel]').addEventListener('click', function () { modal.hidden = true; });
    $('[data-ov-modal-confirm]').addEventListener('click', function () { modal.hidden = true; doAddToCart(); });
    function custEl(k) { return root.querySelector('[data-ov-cust="' + k + '"]'); }
    function validateCustomerInfo() {
      var name = custEl('name'), email = custEl('email'), phone = custEl('phone');
      [name, email, phone].forEach(function (el) { el.classList.remove('ov-invalid'); });
      var nameV = name.value.trim(), emailV = email.value.trim(), phoneV = phone.value.trim();
      if (!nameV) { name.classList.add('ov-invalid'); name.focus(); toast('Please enter your name', 'error'); return false; }
      if (!emailV && !phoneV) {
        email.classList.add('ov-invalid'); phone.classList.add('ov-invalid'); email.focus();
        toast('Add an email or phone number', 'error'); return false;
      }
      if (emailV && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emailV)) {
        email.classList.add('ov-invalid'); email.focus(); toast('Please enter a valid email', 'error'); return false;
      }
      return true;
    }

    $('[data-ov-atc]').addEventListener('click', function () {
      if (!activeZoneIds().length) return;
      if (!validateCustomerInfo()) return;
      // every active zone must have a stored artwork URL before checkout
      var pending = activeZoneIds().filter(function (id) { return !state.zones[id].url; });
      if (pending.length) {
        var up = pending.some(function (id) { return state.zones[id].uploading; });
        toast(up ? 'Artwork still uploading — one sec…' : 'An upload failed — please re-upload', up ? 'info' : 'error');
        return;
      }
      var low = activeZoneIds().some(function (id) { return !state.zones[id].isOk; });
      if (low) { modal.hidden = false; return; }
      doAddToCart();
    });

    function buildProperties(designId) {
      var props = { 'Garment color': color().name, '_color_id': state.colorId, '_design_id': designId };
      // Customer-provided info (visible to customer + admin)
      var custLabels = { name: 'Name', email: 'Email', phone: 'Phone', po: 'PO number', notes: 'Order notes' };
      $all('[data-ov-cust]').forEach(function (el) {
        var v = (el.value || '').trim();
        if (v) props[custLabels[el.getAttribute('data-ov-cust')]] = v;
      });
      if (state.graphicFee) props['Design assistance'] = 'Yes (+' + fmt(CFG.graphicFee) + ')';
      CFG.zones.forEach(function (z) {
        var img = state.zones[z.id];
        props['_' + z.id + '_url'] = img ? img.url : null;
        props['_' + z.id + '_filename'] = img ? img.name : null;
        props['_' + z.id + '_dimensions'] = img && img.w ? (img.w + 'x' + img.h) : null;
        props['_' + z.id + '_dpi'] = img ? (img.vector ? 'vector' : img.dpi) : null;
        props['_' + z.id + '_dpi_ok'] = img ? (img.vector ? true : img.isOk) : null;
        props['_' + z.id + '_transform'] = img ? JSON.stringify({ scale: Math.round(img.t.scale * 100) / 100, x: Math.round(img.t.x), y: Math.round(img.t.y) }) : null;
      });
      var zp = {}; CFG.zones.forEach(function (z) { zp[z.id] = z.price; });
      props['_zone_prices'] = JSON.stringify(zp);
      props['_graphic_fee'] = state.graphicFee ? CFG.graphicFee : 0;
      return props;
    }

    // Which add-on variant matches the active zone selection (mirrors the bundle pricing)
    function zoneAddonVariant() {
      var a = CFG.addons || {}, ids = activeZoneIds();
      if (!ids.length) return null;
      if (ids.indexOf('pocket') >= 0 && ids.indexOf('back') >= 0) return a.pocketback;
      if (ids.indexOf('front') >= 0 && ids.indexOf('back') >= 0) return a.frontback;
      return a[ids[0]] || null; // single zone (pocket/front/back)
    }
    function buildFeeItems(designId, qty, includeSetup) {
      var items = [], a = CFG.addons || {};
      var zv = zoneAddonVariant();
      if (zv) items.push({ id: zv, quantity: qty, properties: { '_addon': 'print', '_for_design': designId } });
      if (state.graphicFee && a.design) items.push({ id: a.design, quantity: 1, properties: { '_addon': 'design assistance', '_for_design': designId } });
      if (includeSetup && a.manualfee) items.push({ id: a.manualfee, quantity: 1, properties: { '_addon': 'setup fee', '_for_design': designId } });
      return items;
    }

    function resetAtc() { $('[data-ov-atc]').disabled = false; renderTotals(); }

    function addShirtToCart(variantId, qty, props) {
      // Preferred: Yuva cart-drawer pipeline (.Sd_addProduct) so the drawer opens with everything attached
      if (window.jQuery && document.querySelector('[data-side-drawer]')) {
        var form = document.createElement('form');
        form.setAttribute('method', 'post'); form.setAttribute('action', '/cart/add'); form.style.display = 'none';
        var addInput = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); };
        addInput('id', variantId); addInput('quantity', qty);
        Object.keys(props).forEach(function (k) { if (props[k] !== null && props[k] !== undefined) addInput('properties[' + k + ']', props[k]); });
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'Sd_addProduct'; btn.style.display = 'none';
        form.appendChild(btn); document.body.appendChild(form); btn.click();
        setTimeout(function () { if (form.parentNode) form.parentNode.removeChild(form); resetAtc(); }, 1600);
        return;
      }
      // Fallback: AJAX add then go to the cart page
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties: props }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Add to cart failed'); }); return r.json(); })
        .then(function () { toast('Added to cart ✓', 'info'); window.location.href = '/cart'; })
        .catch(function (err) { toast(err.message || 'Add to cart failed', 'error'); resetAtc(); });
    }

    function doAddToCart() {
      var sizes = sizesWithQty();
      if (!sizes.length) { toast('Add a quantity for at least one size', 'error'); return; }
      $('[data-ov-atc]').disabled = true;
      $('[data-ov-atc-label]').textContent = 'Adding…';
      var c = compute();
      var setupId = (CFG.addons || {}).manualfee;

      // Look at the current cart first so the setup fee carries over but is never doubled
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var hasSetup = (cart.items || []).some(function (it) { return String(it.id) === String(setupId); });
          var includeSetup = (c.manual > 0) && !hasSetup;

          var designId = 'ovd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
          var props = buildProperties(designId);
          var feeItems = buildFeeItems(designId, totalUnits(), includeSetup);

          // One shirt line per size, all sharing the same design
          var shirtItems = [];
          sizes.forEach(function (s) {
            var v = variantForSize(s);
            if (v) shirtItems.push({ id: v.id, quantity: state.sizeQty[s], properties: props });
          });
          if (!shirtItems.length) { toast('Selected sizes are unavailable', 'error'); resetAtc(); return; }

          // Add fees + all-but-last shirt via fetch, then the last shirt via the drawer pipeline (opens drawer)
          var last = shirtItems.pop();
          var pre = feeItems.concat(shirtItems);
          var addPre = pre.length
            ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: pre }) })
                .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
            : Promise.resolve();
          addPre.then(function () { addShirtToCart(last.id, last.quantity, props); });
        });
    }

    renderAll();
  }

  function boot() { document.querySelectorAll('.ov-designer').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render hooks
  document.addEventListener('shopify:section:load', boot);
})();
